import React from 'react';

import User from '../../../Api/Models/User';
import ActionButton from '../../elements/ActionButton';
import SortButton, { SortProps } from '../../elements/common/SortButton';
import { TableCell as Cell } from '../../elements/common/TableDetailsRow';
import TableHead from '../../elements/common/TableHead';
import { PERMISSION } from '../../helpers/Permissions';

function UserTableShort({ users, sortProps }: { users: User[]; sortProps: SortProps }) {
    return (
        <table className="table model-list">
            <TableHead>
                <SortButton column="id" {...sortProps} />
                <SortButton column="email" label="E-mail" {...sortProps} />
                <SortButton column="phone" {...sortProps} />
                <div />
            </TableHead>
            <tbody>
                {users.map((user) => (
                    <tr key={user.id}>
                        <td>{user.id}</td>
                        <Cell>{user.email}</Cell>
                        <Cell>{user.phone}</Cell>
                        <td>
                            <ActionButton title="open" url={`/users/${user.id}`} permissions={[PERMISSION.VIEW_USER]} />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default UserTableShort;
